import { gql } from '@apollo/client'

const dashboardBusinessUnitTinyFragment = gql`
  fragment DashboardBusinessUnitTinyFields on BusinessUnitTiny {
    id
    name
    displayName
  }
`

const dashboardEmployeeDisplayTinyInfoFragment = gql`
  fragment DashboardEmployeeDisplayTinyInfoFields on EmployeeDisplayTinyInfo {
    id
    firstName
    lastName
    avatarUrl
  }
`

const dashboardEmployeeWithLevelFragment = gql`
  fragment DashboardEmployeeWithLevelFields on EmployeeWithLevelDTO {
    id
    firstName
    lastName
    avatarUrl
    currentLevel
  }
`

const dashboardBranchOfficeFragment = gql`
  fragment DashboardBranchOfficeFields on BranchOfficeDTO {
    id
    code
    name
  }
`

export const companyManagerDashboardBuOfCompanyRowFragment = gql`
  fragment CompanyManagerDashboardBuOfCompanyRowFields on BusinessUnitWithManagersDTO {
    businessUnit {
      ...DashboardBusinessUnitTinyFields
    }
    buManagers {
      ...DashboardEmployeeDisplayTinyInfoFields
    }
    numberOfEmployees
  }
  ${dashboardBusinessUnitTinyFragment}
  ${dashboardEmployeeDisplayTinyInfoFragment}
`

export const companyManagerDashboardBumOfBusinessUnitRowFragment = gql`
  fragment CompanyManagerDashboardBumOfBusinessUnitRowFields on BUMOfBusinessUnitDTO {
    businessUnit {
      ...DashboardBusinessUnitTinyFields
    }
    buManagers {
      ...DashboardEmployeeWithLevelFields
    }
  }
  ${dashboardBusinessUnitTinyFragment}
  ${dashboardEmployeeWithLevelFragment}
`

export const companyManagerDashboardBoOfCompanyRowFragment = gql`
  fragment CompanyManagerDashboardBoOfCompanyRowFields on BranchOfficeWithEmployeesDTO {
    branchOffice {
      ...DashboardBranchOfficeFields
    }
    employees {
      ...DashboardEmployeeWithLevelFields
    }
  }
  ${dashboardBranchOfficeFragment}
  ${dashboardEmployeeWithLevelFragment}
`
